module.exports = __webpack_public_path__ + "assets/media/morning.789fd6c7.mp3";